module.exports = __webpack_public_path__ + "static/media/banesco-icon-noneOption.28cd466a.svg";